import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class UptimeService {

  private body: any = {
    api_key: 'm780213054-1a3980cdc28a82caa0f9cf16',
    custom_uptime_ratios: '30',
    logs: 1,
    format: 'json'
  };

  constructor(private http: HttpClient) {}

  public getMonitorUptimes() {
    return this.http.post<any>('https://api.uptimerobot.com/v2/getMonitors', this.body);
  }
}
